import Vue from "vue";
import firebase from "firebase";
import VueRouter from "vue-router";
//import store from "./store";

import Lists from "./views/Lists.vue";
import Editor from "./views/Editor.vue";
import Login from "./views/Login.vue";
import Register from "./views/Register.vue";
import Settings from "./views/Settings.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "*",
    redirect: "/"
  },
  {
    path: "/",
    name: "Lists",
    component: Lists,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/editor/:id",
    name: "editor",
    component: Editor,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/login",
    name: "Login",
    component: Login
  },
  {
    path: "/register",
    name: "Register",
    component: Register
  },
  {
    path: "/settings",
    name: "Settings",
    component: Settings,
    meta: {
      requiresAuth: true
    }
  }
];

const router = new VueRouter({
  routes
});

router.beforeEach((to, from, next) => {
  const currentUser = firebase.auth().currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  if (requiresAuth && !currentUser) next("login");
  else if (!requiresAuth && currentUser) next("Lists");
  else next();
});

export default router;
